<template>
  <div class="col-12 sector logistic-sector px-3">
    <div class="row">
      <div class="sector__header">
        {{ t("carts.shippingMethod") }}
      </div>
      <div class="sector__content">
        <div class="row">
          <el-radio-group v-model="form.logistic_type" size="large" class="w-100 row m-0 justify-content-center">
            <el-radio
              v-for="logistic in availableLogisticTypes"
              :key="logistic.type"
              :label="logistic.type"
              border
              class="col-12 col-sm-3 mb-2 mx-1"
              :style="{ minHeight: '5rem', margin: '0 0rem 0 0' }"
            >
              {{ logistic.name }}
              <div class="text-black-50">{{ logistic.description }}</div>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel, useVModels } from '@vueuse/core'

const props = defineProps({
  modelValue: Object,
  availableLogisticTypes: Object,
})
const emit = defineEmits(['update:modelValue'])

const { t, locale } = useI18n()
const form = useVModel(props, 'modelValue', emit)

</script>